import throttle from 'nespresso-library/src/utils/throttle'
import Tracking from 'nespresso-library/src/core/tracking'
import IntersectionObserverManager from 'nespresso-library/src/utils/IntersectionObserverManager'
import { offset, on, off, outerHeight } from 'gaspard'

const iom = new IntersectionObserverManager({
    isLandscape: {
        above: [0],
        rootMargin: '0% 0%'
    },
    isPortrait: {
        above: [0],
        rootMargin: '0% 0%'
    }
})

export default {
    props: {
        trackingLabel: String
    },
    mounted () {
        this._tracking = new ZoneTracking(this)
    },
    beforeDestroy () {
        if (!iom.hasIntersectionObserver()) {
            this._tracking.destroy()
        }
    }
}

class ZoneTracking {
    el = null
    id = null
    label = null
    landingLabel = null
    scrollHandler = null
    constructor (component) {
        this.el = component.$el
        this.id = component.id
        this.label = component.trackingLabel
        this.landingLabel = component.$trackingLandingLabel
        this.sectionLabels = component.$mapSectionsName

        if (iom.hasIntersectionObserver()) {
            iom.addItem({
                element: this.el,
                onViewportEnter: () => this.track()
            })
        } else {
            this.scrollHandler = throttle(this.isInViewport.bind(this), 500)
            on(window, 'scroll', this.scrollHandler)
        }
    }
    isInViewport () {
        const section = this.el
        const scrollTop = window.pageYOffset
        const sectionTop = offset(section).top
        const sectionHeight = outerHeight(section)
        const viewPortBottom = scrollTop + window.innerHeight
        if ((viewPortBottom >= sectionTop + sectionHeight / 2) && (scrollTop <= sectionTop || (viewPortBottom <= sectionTop + sectionHeight * 1.5))) {
            this.track()
            this.destroy()
        }
    }
    track () {
        if ('requestIdleCallback' in window) {
            window.requestIdleCallback(() => this.runTrack())
        } else {
            window.setTimeout(() => this.runTrack(), 1)
        }
    }
    runTrack () {
        const sectionName = this.label || this.sectionLabels[this.id]
        if (sectionName) {
            Tracking.customEvent({
                category: 'User Engagement',
                action: 'Scroll',
                label: `${this.landingLabel} - ${sectionName}`,
                interaction: 1
            })
        } else {
            console.warn('This Zone is not tracked', this)
        }
    }
    destroy () {
        off(window, 'scroll', this.scrollHandler)
    }
}



// WEBPACK FOOTER //
// ./node_modules/gvue/src/assets/js/mixins/ZoneTracking.js